<template>
  <div class="dg-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">智能数据管理与治理平台</span>
    </nav>

    <!-- 英雄区（产品Banner） -->
    <section class="dg-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>智能数据管理与治理平台<br><span style="color: var(--dg-accent-blue);">Intelligent Data Governance Suite</span></h1>
        <p class="dg-subhead">AI驱动数据治理 · 智能体协同管理 · 数据资产化运营，构建"数据采集—数据治理—数据资产—数据分析—AI智能应用"一体化平台。</p>        
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="dg-btn dg-btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="dg-btn dg-btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="dg-keyword-cloud">
        <h2 class="dg-keyword-tag highlight">数据治理平台</h2>
        <h2 class="dg-keyword-tag">数据资产管理系统</h2>
        <h2 class="dg-keyword-tag">企业数据中台</h2>
        <h2 class="dg-keyword-tag">数据质量管理系统</h2>
        <h2 class="dg-keyword-tag">主数据管理</h2>
        <h2 class="dg-keyword-tag">AI数据治理</h2>
        <h2 class="dg-keyword-tag">智能数据分析</h2>
        <h2 class="dg-keyword-tag">数据合规</h2>
        <h2 class="dg-keyword-tag">数据血缘</h2>
        <h2 class="dg-keyword-tag">数据资产目录</h2>
      </div>
    </section>

    <!-- 行业背景与痛点 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 数字化转型背景与核心痛点</h2>
      <div class="dg-card-grid-3">
        <div class="dg-feature-card">
          <h3>数据分散，缺乏统一管理</h3>
          <p>多系统并存，主数据不一致，数据口径冲突，形成数据孤岛。</p>
        </div>
        <div class="dg-feature-card">
          <h3>数据质量难以保障</h3>
          <p>缺失值多、重复数据严重、异常数据难发现，影响决策准确性。</p>
        </div>
        <div class="dg-feature-card">
          <h3>数据资产价值难衡量</h3>
          <p>数据资源未盘点，无法量化评估，共享机制缺失，资产化受阻。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">在数据资产入表、数据要素市场化趋势下，企业亟需构建智能化、一体化的数据治理平台。</p>
    </section>

    <!-- 产品定位 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 产品定位</h2>
      <div class="dg-arch-card" style="background: #F5F5F5; color: white;">
        <p style="font-size: 1.2rem; max-width: 900px; margin: 0 auto;">融合数据管理、数据治理、数据资产管理、AI大模型与多智能体协同，实现数据可见、可信、可控、可用、可增值，打造数据驱动型智能企业。</p>
      </div>
    </section>

    <!-- 核心功能模块（六个卡片，带颜色标识） -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 六大核心能力</h2>
      <div class="dg-card-grid-6">
        <!-- 模块1：全域数据接入与数据中台 -->
        <div class="dg-feature-card">
          <h3>全域数据接入与数据中台</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 多源数据接入（ERP/业务/API/IoT）</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 实时/离线同步</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据标准化与血缘追踪</li>
          </ul>
          <div style="margin-top: 16px;"><span class="dg-keyword-tag">数据中台</span><span class="dg-keyword-tag">数据集成</span></div>
        </div>

        <!-- 模块2：智能数据治理系统 -->
        <div class="dg-feature-card">
          <h3>智能数据治理系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据标准管理</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 主数据管理（MDM）</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据质量评分与监测</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> AI自动匹配标准</li>
          </ul>
          <div style="margin-top: 16px;"><span class="dg-keyword-tag">数据质量</span><span class="dg-keyword-tag">主数据</span></div>
        </div>

        <!-- 模块3：数据资产管理平台 -->
        <div class="dg-feature-card">
          <h3>数据资产管理平台</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据资产目录管理</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 自动标签与价值评估</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据使用统计分析</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 资产画像生成</li>
          </ul>
          <div style="margin-top: 16px;"><span class="dg-keyword-tag">资产目录</span><span class="dg-keyword-tag">价值评估</span></div>
        </div>

        <!-- 模块4：AI智能数据分析平台 -->
        <div class="dg-feature-card">
          <h3>AI智能数据分析平台</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 自然语言查询</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 自动SQL生成</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成分析报告</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 趋势预测模型</li>
          </ul>
          <div style="margin-top: 16px;"><span class="dg-keyword-tag">AI分析</span><span class="dg-keyword-tag">自然语言查询</span></div>
        </div>

        <!-- 模块5：数据治理智能体体系（AI Agent） -->
        <div class="dg-feature-card">
          <h3>数据治理智能体体系</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据质量智能体</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据标准智能体</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据分析智能体</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据安全与合规智能体</li>
          </ul>
          <div style="margin-top: 16px;"><span class="dg-keyword-tag">AI智能体</span><span class="dg-keyword-tag">多智能体协同</span></div>
        </div>

        <!-- 模块6：数据治理驾驶舱 -->
        <div class="dg-feature-card">
          <h3>数据治理驾驶舱</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据治理总览大屏</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据质量评分看板</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据资产热度图</li>
            <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 风险与趋势预测</li>
          </ul>
          <div style="margin-top: 16px;"><span class="dg-keyword-tag">可视化</span><span class="dg-keyword-tag">驾驶舱</span></div>
        </div>
      </div>
    </section>

    <!-- 技术架构亮点 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 技术架构亮点</h2>
      <div class="dg-arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="dg-compliance-badge">企业级数据中台</span>
          <span class="dg-compliance-badge">元数据管理</span>
          <span class="dg-compliance-badge">知识图谱</span>
          <span class="dg-compliance-badge">大语言模型</span>
          <span class="dg-compliance-badge">多智能体框架</span>
          <span class="dg-compliance-badge">微服务架构</span>
        </div>
        <div class="dg-arch-grid">
          <div class="dg-arch-item">
            <h4>元数据与数据图谱</h4>
            <p>自动识别元数据，构建数据血缘与知识图谱，支撑数据溯源与影响分析。</p>
          </div>
          <div class="dg-arch-item">
            <h4>大模型语义引擎</h4>
            <p>基于LLM的自然语言查询、智能数据标准匹配、异常解释与报告生成。</p>
          </div>
          <div class="dg-arch-item">
            <h4>多智能体协同框架</h4>
            <p>质量、标准、分析、安全智能体协同工作，实现数据治理自动化闭环。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型应用场景 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 典型应用场景</h2>
      <div class="dg-card-grid-4">
        <div class="dg-feature-card">
          <h3>集团企业</h3>
          <p>跨子公司数据统一治理，投资与财务数据整合，主数据统一。</p>
        </div>
        <div class="dg-feature-card">
          <h3>金融机构</h3>
          <p>客户数据统一管理，风险数据治理，满足监管合规。</p>
        </div>
        <div class="dg-feature-card">
          <h3>政府与监管单位</h3>
          <p>数据资源共享，数据资产盘点，辅助决策分析。</p>
        </div>
        <div class="dg-feature-card">
          <h3>制造与能源企业</h3>
          <p>设备数据分析，供应链数据治理，提升运营效率。</p>
        </div>
      </div>
    </section>

    <!-- 产品核心优势 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 产品核心优势</h2>
      <div class="dg-card-grid-4">
        <div class="dg-feature-card">
          <h3>全链条数据治理闭环</h3>
          <p>数据采集 → 治理 → 资产化 → 分析 → AI赋能，一站式解决。</p>
        </div>
        <div class="dg-feature-card">
          <h3>AI驱动智能管理</h3>
          <p>从人工管理升级到智能管理，大幅提升治理效率。</p>
        </div>
        <div class="dg-feature-card">
          <h3>数据资产可量化</h3>
          <p>帮助企业实现数据价值评估与运营管理，支撑数据资产入表。</p>
        </div>
        <div class="dg-feature-card">
          <h3>安全与合规并重</h3>
          <p>满足数据安全法、等保2.0等监管要求。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 关键成果与价值</h2>
      <div class="dg-stat-grid">
        <div class="dg-stat-card">
          <div class="dg-stat-number">50%+</div>
          <p>数据质量问题减少</p>
        </div>
        <div class="dg-stat-card">
          <div class="dg-stat-number">60%</div>
          <p>数据开发效率提升</p>
        </div>
        <div class="dg-stat-card">
          <div class="dg-stat-number">实时</div>
          <p>数据血缘追踪</p>
        </div>
        <div class="dg-stat-card">
          <div class="dg-stat-number">100%</div>
          <p>数据资产可盘点</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 统一数据标准，消除数据孤岛</li>
          <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 智能数据质量监控与修复建议</li>
          <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 数据资产目录自动构建与价值评估</li>
          <li class="dg-list-item"><i class="fa-regular fa-circle-check"></i> 自然语言查询，人人可用数据分析</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户群体 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 适用客户群体</h2>
      <div class="dg-client-tags">
        <span class="dg-client-tag">央企集团</span>
        <span class="dg-client-tag">地方国企</span>
        <span class="dg-client-tag">金融机构</span>
        <span class="dg-client-tag">政府单位</span>
        <span class="dg-client-tag">能源企业</span>
        <span class="dg-client-tag">制造企业</span>
        <span class="dg-client-tag">数据中台部门</span>
        <span class="dg-client-tag">IT部门</span>
      </div>
    </section>

    <!-- 相关产品与平台 -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 相关产品与平台</h2>
      <div class="dg-related-grid">
        <router-link to="/product/smart-audit-risk" class="dg-related-card">
          <h3>智慧审计与全面风险管理平台</h3>
          <p>审计数字化 + 风险管理一体化，构建智能审计闭环体系。</p>
        </router-link>
        <router-link to="/product/risk-compliance-platform" class="dg-related-card">
          <h3>风控合规数字化平台</h3>
          <p>风险识别、合规评估、持续监控，助力企业合规运营。</p>
        </router-link>
        <router-link to="/product/ai-agent" class="dg-related-card">
          <h3>AI智能体平台</h3>
          <p>多智能体协同分析与治理，释放数据价值与生产力。</p>
        </router-link>
        <router-link to="/product/penetrating-supervision" class="dg-related-card">
          <h3>穿透式监管平台</h3>
          <p>全链条风险穿透与责任追溯，实现穿透式数字化监管。</p>
        </router-link>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="dg-container">
      <h2><i class="fa-regular fa-star"></i> 常见问题</h2>
      <div class="dg-faq-list">
        <div class="dg-faq-item">
          <div class="dg-faq-question"><i class="fa-regular fa-message"></i> 平台如何实现多源数据接入？</div>
          <div class="dg-faq-answer">支持数据库直连、API、消息队列、文件上传等多种方式，内置丰富的数据源连接器，可快速对接ERP、财务、业务系统等。</div>
        </div>
        <div class="dg-faq-item">
          <div class="dg-faq-question"><i class="fa-regular fa-message"></i> 数据质量如何自动监测与修复？</div>
          <div class="dg-faq-answer">平台内置质量规则库，自动扫描数据质量，生成质量评分和异常报告，并通过智能体推送修复建议，支持闭环跟踪。</div>
        </div>
        <div class="dg-faq-item">
          <div class="dg-faq-question"><i class="fa-regular fa-message"></i> 数据资产目录如何构建？</div>
          <div class="dg-faq-answer">自动扫描元数据，结合AI自动分类打标，生成数据资产目录和价值评估，支持多维度检索与共享申请。</div>
        </div>
        <div class="dg-faq-item">
          <div class="dg-faq-question"><i class="fa-regular fa-message"></i> 是否支持私有化部署？</div>
          <div class="dg-faq-answer">支持全栈私有化部署，满足企业数据安全与合规要求，也可提供混合云方案。</div>
        </div>
        <div class="dg-faq-item">
          <div class="dg-faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="dg-faq-answer">一般3-4个月完成试点上线，包括数据源梳理、标准制定、平台配置和人员培训。</div>
        </div>
      </div>
    </section>

    <!-- 预约咨询 -->
    <section id="contact" class="section cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建可信、统一的数据治理与 AI 治理体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>顶层设计 / 数据战略规划</option>
              <option>数据标准与数据质量</option>
              <option>主数据管理</option>
              <option>数据资产盘点 / DCMM 评估</option>
              <option>AI 治理与大模型应用</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「数据治理」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ProductDetailDataGovernance',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitForm() {
      alert('表单已提交');
      this.showModal = false;
    },
    showQrCode() {
      this.showQrModal = true;
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.dg-page {
  --dg-primary-dark: #1D4E4E;
  --dg-primary-soft: #e9f3f2;
  --dg-accent-gold: #D4AF37;
  --dg-accent-blue: #2A7DE1;
  --dg-gray-light: #f8fafc;
  --dg-gray-border: #e2e8f0;
  --dg-text-dark: #0f2a2a;
  --dg-text-regular: #2d3f4b;
  --dg-white: #ffffff;
  --dg-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  background-color: #ffffff;
  color: var(--dg-text-regular);
  font-size: 16px;
  line-height: 1.8;
}

.dg-page *, .dg-page *::before, .dg-page *::after {
  box-sizing: border-box;
}

.dg-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

.dg-page section {
  padding: 40px 16px;
}

.dg-page h1, .dg-page h2, .dg-page h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--dg-text-dark);
}

.dg-page h1 {
  font-size: 42px;
  line-height: 1.2;
}

.dg-page h2 {
  font-size: 28px;
  margin-bottom: 24px;
}

.dg-page h2 i {
  color: var(--dg-accent-blue);
  margin-right: 8px;
}

.dg-page h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.dg-subhead {
  font-size: 18px;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.dg-btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.dg-btn-primary {
  background-color: var(--dg-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.dg-btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.dg-btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--dg-primary-dark);
  color: var(--dg-primary-dark);
}

.dg-btn-outline:hover {
  background-color: var(--dg-primary-dark);
  color: white;
}

.dg-btn-accent {
  background-color: var(--dg-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.dg-btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 导航 */
.dg-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid var(--dg-gray-border);
  background-color: white;
  margin-bottom: 20px;
}

.dg-logo {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--dg-primary-dark);
}

.dg-logo span {
  color: var(--dg-accent-gold);
}

.dg-back-link {
  text-decoration: none;
  color: var(--dg-primary-dark);
  font-weight: 500;
  text-align: right;
  gap: 8px;
  border: 1px solid var(--dg-gray-border);
  padding: 8px 16px;
  border-radius: 40px;
  transition: 0.2s;
}

.dg-back-link:hover {
  background-color: var(--dg-primary-soft);
  border-color: var(--dg-primary-dark);
}

/* 关键词标签云 */
.dg-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.dg-keyword-tag {
  background: var(--dg-primary-soft);
  color: var(--dg-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.dg-keyword-tag.highlight {
  background: var(--dg-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.dg-card-grid-3, .dg-card-grid-4, .dg-card-grid-6 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.dg-card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.dg-card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.dg-card-grid-6 {
  grid-template-columns: repeat(3, 1fr);
}

.dg-feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--dg-shadow);
  border: 1px solid var(--dg-gray-border);
  transition: transform 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dg-feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.dg-card-icon {
  font-size: 2.5rem;
  color: var(--dg-primary-dark);
  margin-bottom: 20px;
}

.dg-list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.dg-list-item i {
  color: var(--dg-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.dg-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.dg-stat-card {
  background: var(--dg-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.dg-stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--dg-primary-dark);
  margin-bottom: 8px;
}

.dg-client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.dg-client-tag {
  background: white;
  border: 1px solid var(--dg-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--dg-text-dark);
}

/* 技术架构卡片 */
.dg-arch-card {
  background: var(--dg-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.dg-arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.dg-arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.dg-compliance-badge {
  display: inline-block;
  background: var(--dg-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.dg-faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.dg-faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--dg-gray-border);
}

.dg-faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--dg-text-dark);
}

.dg-faq-question i {
  color: var(--dg-accent-gold);
}

.dg-faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

/* ============ 预约咨询区段 ============ */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}





/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--dg-accent-blue);
  font-weight: 600;
}


/* 中部CTA */
.dg-mid-cta {
  background: var(--dg-primary-dark);
  border-radius: 32px;
  padding: 48px 40px;
  text-align: center;
  color: white;
}

/* 相关产品网格 */
.dg-related-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.dg-related-card {
  display: block;
  background: white;
  border: 1px solid var(--dg-gray-border);
  border-radius: 24px;
  padding: 28px 24px;
  text-decoration: none;
  color: var(--dg-text-regular);
  transition: transform 0.2s, box-shadow 0.2s;
}

.dg-related-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.dg-related-card i {
  font-size: 2rem;
  color: var(--dg-accent-blue);
  margin-bottom: 16px;
  display: block;
}

.dg-related-card h3 {
  color: var(--dg-text-dark);
  margin-bottom: 8px;
}

.dg-related-card p {
  font-size: 14px;
  color: #5f7a8a;
}



/* 底部转化 */

.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}


.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
}

.qr-code {
  display: inline-block;
  background: white;
  padding: 12px 24px;
  border-radius: 60px;
  margin-top: 20px;
  cursor: pointer;
  color: var(--deep-indigo);
}


.btn-primary {
  display: inline-block;
  background: #1F3F8F;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31,63,143,0.3);
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}
.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}




/* 响应式 */
@media (max-width: 1100px) {
  .dg-card-grid-6 {
    grid-template-columns: repeat(2, 1fr);
  }
  .dg-related-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .dg-card-grid-3, .dg-card-grid-4, .dg-card-grid-6, .dg-stat-grid, .dg-arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .dg-related-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .dg-card-grid-3, .dg-card-grid-4, .dg-card-grid-6, .dg-stat-grid, .dg-arch-grid {
    grid-template-columns: 1fr;
  }
  .dg-related-grid {
    grid-template-columns: 1fr;
  }
  .dg-page h1 { font-size: 32px; }
  .dg-navbar { flex-direction: column; gap: 16px; }
}
</style>
